/**
 * @typedef {object} ReduxState
 * @property {{[key: string]: object, list: object[]}} competitions
 * @property {{[key: string]: object, list: object[]}} seasons
 * @property {{[key: string]: object, list: object[]}} rounds
 * @property {import('./modules/statspro/types').StatsProState} statspro
 */

/**
 * @typedef {( any ) => { type: string, payload: any }} ActionCreator
 */

/**
 * @typedef {object} SignalActionObject
 * @property {string} REQUEST
 * @property {string} SUCCESS
 * @property {string} FAILURE
 * @property {ActionCreator} request
 * @property {ActionCreator} success
 * @property {ActionCreator} failure
 */